const getConfigByType = {
  app: {
    getNextItem: 'getMenuInfo',
    nextType: ['menu'],
    submitMethod: '',
    clearType: ['menu', 'col', 'row', 'component', 'department']
  },
  systemRow: {
    submitMethod: 'submitSystemRow'
  },
  menu: {
    getNextItem: 'getOtherPermission',
    nextType: ['row', 'col', 'component'],
    submitMethod: 'submitMenu',
    clearType: ['col', 'row', 'component', 'department']
  },
  col: {
    submitMethod: 'submitOthers',
    submitKey: 'dataColRuleAuths',
    submitUrl: '/v1/orgUserAuth/editOrgUserDataColRule'
  },
  row: {
    submitMethod: 'submitOthers',
    submitKey: 'dataRowRuleAuths',
    submitUrl: '/v1/orgUserAuth/editOrgUserDataRowRule',
    clearType: []
  },
  component: {
    submitMethod: 'submitOthers',
    submitKey: 'pageComponentAuths',
    submitUrl: '/v1/orgUserAuth/editOrgUserPageComponent'
  },
  department: {
    submitMethod: 'submitOthers',
    submitKey: '',
    submitUrl: ''
  }
};
const permissionRoleConfig = {
  role: {
    getNextItem: 'getMenuInfo',
    nextType: ['menu'],
    submitMethod: 'submitRole',
    saveIdName: 'currentRoleId',
    clearType: ['menu', 'col', 'row', 'component', 'department', 'systemRow'],
    checkChangeMehods: 'roleCheckChange'
  },
  app: {
    getNextItem: 'getMenuInfo',
    nextType: ['menu'],
    submitMethod: '',
    saveIdName: 'currentAppId',
    clearType: ['menu', 'col', 'row', 'component', 'department']
  },
  systemRow: {
    submitMethod: 'submitSystemRow'
  },
  menu: {
    getNextItem: 'getOtherPermission',
    nextType: ['row', 'col', 'component'],
    submitMethod: 'submitMenu',
    saveIdName: 'currentMenuId',
    clearType: ['col', 'row', 'component', 'department'],
    checkChangeMehods: 'menuCheckChange'
  },
  col: {
    submitMethod: 'submitOthers',
    submitKey: 'dataColRuleAuths',
    submitUrl: '/v1/orgUserAuth/editOrgUserRoleDataColRule'
  },
  row: {
    submitMethod: 'submitOthers',
    submitKey: 'dataRowRuleAuths',
    submitUrl: '/v1/orgUserAuth/editOrgUserRoleDataRowRule',
    clearType: []
  },
  component: {
    submitMethod: 'submitOthers',
    submitKey: 'pageComponentAuths',
    submitUrl: '/v1/orgUserAuth/editOrgUserRolePageComponent'
  },
  department: {
    submitMethod: '',
    submitKey: '',
    submitUrl: '',
    clearType: []
  }
};
export { getConfigByType, permissionRoleConfig };
